/*
https://davidwalsh.name/javascript-debounce-function
*/
export function debounce(func, wait, immediate) {
    let timeout;
    return function returnFn(...rest) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const context = this;
        const args = rest;
        const later = function executeFn() {
            timeout = null;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (!immediate) {
                func.apply(context, args);
            }
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (callNow) {
            func.apply(context, args);
        }
    };
}
